import { PropsWithChildren } from 'react'

import styles from './SimpleList.module.scss'

export const SimpleList: React.FC<PropsWithChildren> = ({ children }) => (
  <ul className={styles.simpleList}>{children}</ul>
)
